export const patternForDecimalNumber = /^\d+(\.\d{0,2}|\.)?/;
